export default function registerModalService(app) {
  app.config.globalProperties.$bvModal = {
    msgBoxConfirm(message) {
      return Promise.resolve(window.confirm(message))
    },
  }
}
